import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const FiltersContext = createContext();
const FiltersActionsContext = createContext();

export const useFiltersContext = () => useContext(FiltersContext);
export const useFiltersActionsContext = () => useContext(FiltersActionsContext);

const FiltersContextProvider = ({ children }) => {
  const location = useLocation();

  const [filters, setFilters] = useState({});
  const [areFiltersTouched, setFiltersTouched] = useState(false);

  const onSetFilters = (
    updatedFilters,
    config = { shouldUpdateTouchedStatus: true }
  ) => {
    if (config.shouldUpdateTouchedStatus) {
      setFiltersTouched(true);
    }
    setFilters(updatedFilters);
  };

  useEffect(() => {
    if (!location.pathname.includes('report-an-issue')) {
      setFilters({});
      setFiltersTouched(false);
    }
  }, [location.pathname]);

  return (
    <FiltersContext.Provider value={filters}>
      <FiltersActionsContext.Provider
        value={{ setFilters: onSetFilters, areFiltersTouched }}
      >
        {children}
      </FiltersActionsContext.Provider>
    </FiltersContext.Provider>
  );
};

FiltersContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default FiltersContextProvider;
